import React, { FunctionComponent } from 'react'
import styles from './FeatureBlockAssistant.module.scss'
import { FeatureBlockAssistantProps } from './FeatureBlockAssistant.model'
import { FormBlock, Switch } from '../../../shared'

export const FeatureBlockAssistant: FunctionComponent<FeatureBlockAssistantProps> = ({
  identityVigilanceOfficerEnabled,
  onIdentityVigilanceOfficerChange,
}) => {
  return (
    <div>
      <FormBlock label="Fonctionnalités" icon="profile">
        <div className={styles.features}>
          <div className={styles.featuresItem}>
            <Switch
              name="Réferent en identitovigilance"
              checked={identityVigilanceOfficerEnabled}
              onChange={onIdentityVigilanceOfficerChange}
              testId="switch-user_features-identity-vigilance-officer-enable"
            />
          </div>
        </div>
      </FormBlock>
    </div>
  )
}
